import type { ResponseItem } from '@app/src/types/resourceExplorer'
import { createContext, useContext } from 'react'

export type PreviousNumberAnswersContextProps = {
  previousNumberAnswers: ResponseItem[]
}

const PreviousNumberAnswersContext = createContext<PreviousNumberAnswersContextProps>({
  previousNumberAnswers: [],
})

export const usePreviousNumberAnswers = (): PreviousNumberAnswersContextProps => {
  return useContext(PreviousNumberAnswersContext)
}

export default PreviousNumberAnswersContext
